var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useCallback, useEffect, useRef } from 'react';
import { useManageWorkplaceServiceRequest } from './useManageWorkplaceServiceRequest';
import { useGetMeetingServiceRequestsForEventBySpaceIdLazyQuery, } from '../../generated/graphql';
export var useWorkplaceServiceRequest = function (_a) {
    var spaceId = _a.spaceId, onError = _a.onError, recurrenceId = _a.recurrenceId, eventUid = _a.eventUid, setWorkplaceServiceRequestFormStatus = _a.setWorkplaceServiceRequestFormStatus;
    var workplaceServicesEnabled = useManageWorkplaceServiceRequest(undefined).workplaceServicesEnabled;
    /* @TODO having to use a ref here is a hack, we should be able to use the onError prop directly */
    var onErrorRef = useRef(onError);
    onErrorRef.current = onError;
    var _b = __read(useGetMeetingServiceRequestsForEventBySpaceIdLazyQuery(), 2), getSpaceForMeetingService = _b[0], _c = _b[1], spaceForMeetingServiceData = _c.data, spaceForMeetingServiceLoading = _c.loading, spaceForMeetingServiceError = _c.error, refetchSpaceForMeetingService = _c.refetch;
    var handleGetSpaceForMeetingService = useCallback(function (variables, fetchPolicy) {
        getSpaceForMeetingService({
            variables: variables,
            fetchPolicy: fetchPolicy || 'network-only',
        });
    }, [getSpaceForMeetingService]);
    useEffect(function () {
        if (!workplaceServicesEnabled) {
            return;
        }
        handleGetSpaceForMeetingService({
            spaceId: spaceId.toString(),
            eventInstance: {
                robinEventId: undefined,
                ical: {
                    uid: eventUid,
                    recurrenceId: recurrenceId !== null && recurrenceId !== void 0 ? recurrenceId : null,
                },
            },
        });
    }, [
        eventUid,
        handleGetSpaceForMeetingService,
        spaceId,
        workplaceServicesEnabled,
        recurrenceId,
    ]);
    var handleWorkplaceServiceError = function (options) {
        if (!spaceId) {
            return;
        }
        /* @TODO should an error close the form? */
        // setWorkplaceServiceRequestFormStatus(undefined);
        if (options === null || options === void 0 ? void 0 : options.error) {
            onError(new Error(options.error));
        }
        if (options === null || options === void 0 ? void 0 : options.shouldRefetch) {
            handleGetSpaceForMeetingService({
                spaceId: spaceId.toString(),
                eventInstance: {
                    robinEventId: undefined,
                    ical: {
                        uid: eventUid,
                        recurrenceId: recurrenceId,
                    },
                },
            }, 'network-only');
        }
    };
    var onSuccessfulRequest = useCallback(function () {
        handleGetSpaceForMeetingService({
            spaceId: spaceId.toString(),
            eventInstance: {
                robinEventId: undefined,
                ical: {
                    uid: eventUid,
                    recurrenceId: recurrenceId !== null && recurrenceId !== void 0 ? recurrenceId : null,
                },
            },
        });
    }, [handleGetSpaceForMeetingService, spaceId, eventUid, recurrenceId]);
    useEffect(function () {
        var _a;
        if (spaceForMeetingServiceError) {
            /* @TODO Add back toast error */
            (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, new Error(spaceForMeetingServiceError.message));
        }
    }, [spaceForMeetingServiceError]);
    return {
        handleWorkplaceServiceError: handleWorkplaceServiceError,
        onSuccessfulRequest: onSuccessfulRequest,
        spaceForMeetingServiceData: spaceForMeetingServiceData,
        spaceForMeetingServiceLoading: spaceForMeetingServiceLoading,
        spaceForMeetingServiceError: spaceForMeetingServiceError,
        refetchSpaceForMeetingService: refetchSpaceForMeetingService,
        handleGetSpaceForMeetingService: handleGetSpaceForMeetingService,
    };
};
